<div
  class="feedback-box"
  [tabIndex]="-1"
  [ngClass]="{ expanded: expanded, 'lateral-expand': lateralExpand }"
  (mouseenter)="onHoverText()"
  (focus)="onHoverText()"
  (mouseleave)="onHoverOut()"
  (blur)="onHoverOut()"
>
  <motif-icon
    *ngIf="!expanded"
    [tabIndex]="0"
    [iconFunction]="IconoirMessage"
    size="20"
    class="message-icon"
    (click)="expandFeedbackBox()"
    (keydown.enter)="expandFeedbackBox()"
    role="button"
    aria-label="Open Feedback box"
    aria-live="polite"
  ></motif-icon>

  <p
    *ngIf="lateralExpand && !expanded"
    class="lateral-text"
    (click)="expandFeedbackBox()"
  >
    | Tell us what we can improve!
  </p>

  <div class="header-line" *ngIf="expanded">
    <h3 class="feedback-header">Help us improve!</h3>
    <motif-icon
      [iconFunction]="IconoirXmark"
      size="20"
      role="button"
      class="x-mark-icon"
      [tabIndex]="0"
      aria-label="Close Feedback box"
      aria-live="polite"
      (click)="closeFeedbackBox()"
      (keydown.enter)="closeFeedbackBox()"
    ></motif-icon>
  </div>

  @if (surveyForm){
  <form
    [formGroup]="surveyForm"
    (ngSubmit)="submitFeedback()"
    class="motif-theme-light feedback-form"
    *ngIf="expanded"
  >
    <ol class="survey-question-list">
      @if (questionFormGroups){
      <!--  -->
      @for (question of questions; let i = $index; track $index) {
      <li class="survey-question-list-item">
        {{ question.text }}
      </li>
      <div class="question-wrapper">
        <app-feedback-question
          [question]="question"
          [formGroup]="questionFormGroups[i]"
        ></app-feedback-question>
      </div>
      }
      <!-- END @for questions -->
      }
      <!-- END @if questionFormGroups -->
    </ol>
    <motif-button
      variant="primary-alt"
      class="motif-theme-dark"
      type="submit"
      [disabled]="isSubmitDisabled"
      aria-label="Submit Feedback"
      aria-live="polite"
      (click)="submitFeedback()"
    >
      Submit
    </motif-button>
  </form>
  }
</div>
